<template>
  <div class="temperature-units-selector">
    <label>Temperature Units:</label>
    <radio-buttons
      :options="options"
      :value="caseConf.temperatureUnits"
      active-color="green-3"
      :disabled="readonly"
      @input="units => updateTemperatureUnits(units)"
    />
  </div>
</template>

<script>
import RadioButtons from '~lib/common/components/RadioButtons';

export default {
  name: 'temperature-units-selector',
  components: {
    RadioButtons
  },
  props: {
    caseConf: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: [
        {
          value: 'FAHRENHEIT',
          label: 'Fahrenheit',
        },
        {
          value: 'CELSIUS',
          label: 'Celsius',
        },
      ],
    };
  },
  methods: {
    updateTemperatureUnits(temperatureUnits) {
      this.$emit('update', {
        temperatureUnits,
      });
    },
  },
};
</script>

<style scoped>
label {
  display: block;
  line-height: normal;
  margin-bottom: 2px;
}
</style>